import React from 'react';
import { handleImage } from '../helper';

export default function useFileZone(mainState, saveMethod) {

	const [state, setState] = mainState;

  const ref = React.createRef();
  const stopEvent = (event) => {
	  event.preventDefault();
	  event.stopPropagation();
  };
  const extensionValidation = (name) => {
	  const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
	  return !allowedExtensions.exec(name);
  };
  const handleChange = (event) => {
	  const file = event.target.files[0];
	  console.log('file', file);
	  if(extensionValidation(file.name)) {
		  setState({ ...state, error: true, errorText: 'Solo se aceptan los siguientes formatos de imagen: jpg, jpeg y png' });
		  setTimeout(() => {
			setState({ ...state, error: false, errorText: '' });
		  }, 7000);
	  } else {
		  handleImage(file, saveMethod);
	  }
  };
  const onDrop = (event) => {
	  stopEvent(event);
	  const { files } = event.dataTransfer;
	  const fileArray = [...files];
	  const file = fileArray[0];
	  const l = fileArray.length;
	  if(l > 1) {
		  setState({ ...state, error: true, errorText: 'Se acepta solo un archivo' });
		  setTimeout(() => {
			setState({ ...state, error: false, errorText: '' });
		  }, 7000);
	  }if(extensionValidation(file.name)) {
		  setState({ ...state, error: true, errorText: 'Solo se aceptan los siguientes formatos de imagen: jpg, jpeg y png' });
		  setTimeout(() => {
			setState({ ...state, error: false, errorText: '' });
		  }, 7000);
	  }else{
		  handleImage(file, saveMethod);
		  setState({ ...state, hover: false });
	  }
  };
  const onDragOver = (event) => {
	  stopEvent(event);
	  setState({ ...state, hover: true });
  };
  const onDragLeave = (event) => {
	  stopEvent(event);
	  setState({ ...state, hover: false });
  }
  const onDropZoneClick = () => {
	  ref.current.click();
  };

  return {
	ref,
	handleChange,
	onDrop,
	onDragOver,
	onDragLeave,
	onDropZoneClick
  };
}
